import ArrowRightIcon from "./ArrowRightIcon";
export default ArrowRightIcon;
